import ProductCardRenderer from '../common/product-card-renderer';
const productCardRenderer = ProductCardRenderer();

import Wishlist from '../common/wishlist';
const wishlist = Wishlist();

const renderProducts = (section) => {
  const ids = section.productIds.map((id) => 'gid://shopify/Product/' + id);
  window.ShopifyClient.fetchProducts(ids)
    .then((products) => {
      products.forEach((product) => {
        wishlist.addShopifyProductToViewProducts(product);
      });
      const items = products.map((product) => {
        const item = productCardRenderer.renderShopifyProduct(product);
        return `<div class="fs-media-grid-item">${item}</div>`;
      });
      if (0 < products.length % 3) {
        for (let i = 0; i < 3 - (products.length % 3); i++) {
          items.push(`<div class="fs-media-grid-item"></div>`);
        }
      }
      const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
      const itemsElement = sectionElement.querySelector('.fs-media-grid-items');
      itemsElement.innerHTML = items.join('');

      productCardRenderer.addWishlistButtonListener(itemsElement);
      wishlist.updateButtons();
    })
    .catch((err) => {
      /* console.error(err) */
      const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
      sectionElement.classList.add('hidden');
    });
};

const mediaGridProductsShopifyMain = () => {
  if (!window.fstore.sections) {
    return;
  }
  const sectionTypes = ['popup-media-grid', 'popup-media-grid-collection'];
  window.fstore.sections
    .filter((section) => sectionTypes.includes(section.sectionType))
    .forEach((section) => {
      renderProducts(section);
    });
};

addEventListener('DOMContentLoaded', (event) => {
  mediaGridProductsShopifyMain();
});
